import { FC } from "react"

import { ULoading } from "@/ui-component"

import { useScannerOAuthQueryHandler } from "./useScannerOAuthQueryHandler"

/**
 * Minimal OAuth return page — avoids loading the full Settings shell in the popup.
 * Register with the API / IdP (EasyRx today: `?easyrx=true|false`; generic `?scanner=&oauth=` planned — see `scannerOAuth.ts`).
 */
const IntegrationsOAuthCallback: FC = () => {
  useScannerOAuthQueryHandler({ refetchWhenNoOAuthParam: false })

  return <ULoading isLoading={true} />
}

export default IntegrationsOAuthCallback
